/**
 * Auth Events - Typed event emitter for authentication state changes.
 * Components and services subscribe to token refresh events.
 */

import { Emitter } from 'src/lib/lifecycle';

class AuthEventEmitter {
  private readonly tokenRefreshed = new Emitter();

  on(_event: 'tokenRefreshed', listener: () => void): () => void {
    const sub = this.tokenRefreshed.on(listener);
    return () => sub.dispose();
  }

  emit(_event: 'tokenRefreshed'): void {
    this.tokenRefreshed.fire();
  }
}

export const authEvents = new AuthEventEmitter();
